<template>
  <generic-container
    class="ui active tab segment"
    :title="$t('layers')"
    icon="layer group"
    :show_plus="true"
    :searchable="true"
    @add="add"
    @filter="filter"
  >
    <div class="ui grid">
      <div class="ui eight wide column">
        <div class="ui top attached tabular menu">
          <a
            class="item"
            v-bind:class="{ active: index == 0 }"
            :data-tab="'t' + index"
            v-for="(layer, index) in $props.project.setup.layers"
            :key="index"
            >{{ layer.name }}</a
          >
        </div>
        <div
          class="ui bottom attached tab segment"
          v-bind:class="{ active: index == 0 }"
          :data-tab="'t' + index"
          v-for="(layer, index) in $props.project.setup.layers"
          :key="index"
        >
          <div class="ui grid">
            <div
              class="row"
              v-for="(rw, rwidx) in layer.data"
              :key="rwidx"
              style="padding:0"
            >
              <div
                class="column"
                v-for="(col, clidx) in rw"
                :key="clidx"
                style="padding:0"
              >
                <div
                  class="ui segment"
                  @click="configure_pixel(col)"
                  :style="'background-color:' + col.color"
                  ref="pixel_element"
                  @mousedown="mousedown"
                  @mouseup="is_draggin = false"
                  @mouseover="mouseover"
                ></div>
              </div>
            </div>
          </div>
          <!-- <layer ref="layer" :layer="layer" @clone="clone_layer" /> -->
          -
        </div>
      </div>
      <div class="ui eight wide column">
        <h4 class="ui dividing head">layer</h4>
        <div class="ui form">
          <div class="field">
            <label for="">{{ $t("name") }}</label>
            <input type="text" name="name" />
          </div>
          <div class="field">
            <label for="">{{ $t("options") }}</label>
            <div class="ui mini icon labeled button" @click="clone">
              <i class="copy icon"></i> {{ $t("clone") }}
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("color") }}</label>
              <swatches popover-x="left" swatches="text-advanced" />
            </div>
            <div class="field">
              <label for>{{ $t("tool") }}</label>
              <div class="ui selection dropdown" ref="tool_dropdown">
                <input type="hidden" name="ddwn" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu">
                  <div class="item" data-value="pencil">
                    <i class="pencil icon"></i>{{ $t("pencil") }}
                  </div>
                  <div class="item" data-value="eraser">
                    <i class="eraser icon"></i>{{ $t("eraser") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ui slider" ref="opacity_slider"></div>
          <div class="ui input">
            <input type="text" />
          </div>
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
// import Layer from "@/modules/pixel_art/project/layer/Index";
import filters from "@/filters";
import { v4 } from "uuid";
import { cloneDeep } from "lodash";
import Swatches from "vue-swatches";

export default {
  name: "PixelArtProjectLayerManagement",
  filters: filters,
  props: { project: Object },
  components: {
    GenericContainer,
    Swatches,
    // Layer,
  },
  data() {
    return {
      selected_layer: undefined,
    };
  },
  created() {},
  methods: {
    add() {
      let vm = this;
      vm.project.setup.layers.push({
        name: vm.$t("unnamed"),
        uuid: v4(),
      });
    },
    select_layer(layer) {
      this.selected_layer = layer;
    },
    filter(query) {
      if (!query) this.$props.project.ngn_project_snapshots = this.all_backups;
      else
        this.$props.project.ngn_project_snapshots = this.all_backups.filter(
          (n) => n.snapshot_comment.toUpperCase().includes(query.toUpperCase()),
        );
    },
    clone_layer(layer) {
      let cloned = cloneDeep(layer);
      this.project.setup.layers.push(cloned);
    },
  },
  mounted() {
    setTimeout(() => {
      window.jQuery(".ui.tabular.menu .item").tab();
    }, 1000);
  },
  watch: {},
};
</script>
